export default "__VITE_ASSET__ltfLd1tv__"